export default __webpack_public_path__ + "static/media/avatar_whitney4.b75c3fa0.mp3";